import { ComponentChildren } from 'preact'

export type RenderPropsChildren<P extends Record<string, any>> = (props: P) => ComponentChildren

const emptyRender = () => null

export const extractRenderPropsChildren = (children?: ComponentChildren) => {
  if (typeof children === 'function') {
    return children
  }

  if (Array.isArray(children)) {
    const firstChildren = children[0]
    if (typeof firstChildren === 'function') {
      return firstChildren
    }
  }

  return emptyRender
}
